import React, { useState } from 'react';
import styles from './FindPasswordInputPanel.module.css'; 
import axios from "../../../../utils/api/axios";
import { EMAIL_VERIFICATION, IAM_PATH } from '../../../../utils/Config'; 
import { InnocodeButton, InnocodeDropdown, InnocodeInput } from '@intsoft/innocode-core';

function FindPasswordInputPanel({ onNext }) {
    const [isCustomInput, setIsCustomInput] = useState(false);
    const [customDomain, setCustomDomain] = useState('');
    const [emailValue, setEmailValue] = useState('');
    const [selectedDomain, setSelectedDomain] = useState('naver.com');
    const [isDomainSelectOpen, setIsDomainSelectOpen] = useState(false);
    const [isEmailCodeSendError, setIsEmailCodeSendError] = useState(false);
    const [codeSendErrorText, setCodeSendErrorText] = useState('');

    // 인증 코드 발송 중 상태를 나타내는 플래그
    const [isSending, setIsSending] = useState(false);

    const fullEmail = isCustomInput ? `${emailValue}@${customDomain}` : `${emailValue}@${selectedDomain}`;

    const domainOptions = [
        { label: 'naver.com', value: 'naver.com' },
        { label: 'gmail.com', value: 'gmail.com' },
        { label: 'daum.net', value: 'daum.net' },
        { label: '직접 입력', value: 'custom' },
    ];

    const handleDomainChange = (domain) => {
        if (domain === 'custom') {
            setIsCustomInput(true);
            setSelectedDomain('');
        } else {
            setIsCustomInput(false);
            setSelectedDomain(domain);
        }
        setIsDomainSelectOpen(false);
    };

    const handleSendCode = async () => {
        if (!emailValue || (!selectedDomain && !customDomain)) {
            setIsEmailCodeSendError(true);
            setCodeSendErrorText('이메일 주소를 입력해주세요.');
            return;
        }
        try {
            // 1. 이메일 존재 여부 확인
            const existRes = await axios.post(`${IAM_PATH}/exist`, { unifiedProfileId: fullEmail });

            if (!existRes.data.data) {
                setIsEmailCodeSendError(true);
                setCodeSendErrorText('회원정보가 없는 이메일입니다.');
                setIsSending(false);
                return;
            }

            setIsSending(true);
            setIsEmailCodeSendError(false);

            // 2. 이메일이 존재하지 않으면 인증 코드 발송
            const sendRes = await axios.post(`${EMAIL_VERIFICATION}/email/send?email=${fullEmail}`);
            
            if (sendRes.data.code === 200) {
                onNext(fullEmail);
            } else {
                setIsEmailCodeSendError(true);
                setCodeSendErrorText('인증 코드 발송에 실패했습니다.');
            }

        } catch (error) {
            console.error("이메일 인증 오류:", error);
            setIsEmailCodeSendError(true);
            setCodeSendErrorText('오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
        } finally {
            setIsSending(false);
        }
    };    

    const isNextButtonEnabled = emailValue && (selectedDomain || customDomain);

    return (
        <div className={styles.content_wrapper}>
        <div className={styles.signup_section}>
            <div className={styles.signup_title_row}>
            <div className={`${styles.signup_title}  innocode-typography--title-sm innocode-typography--bold`}>
                비밀번호를 찾을 아이디를 입력해주세요.
            </div>
            </div>
            <div className={styles.signup_form_label_row}>
                <div className={styles.signup_form_input_group}>
                    <div className={styles.signup_form_label_inner}>
                        <div className={styles.signup_form_label}>이메일</div>
                        <div className={styles.signup_form_required}>*</div>
                    </div>
                    <div className={styles.signup_input_group}> 
                        <InnocodeInput
                            value={emailValue} 
                            placeholder="이메일 입력"
                            onChange={(e) => setEmailValue(e.target.value)}
                            className={styles.innocodeInput}
                            /> 
                        <span className={styles.captionNormal}>@</span>
                        <InnocodeInput
                            value={isCustomInput ? customDomain : selectedDomain} 
                            placeholder="도메인 입력"
                            onChange={(e) => setCustomDomain(e.target.value)}
                            disabled={!isCustomInput}
                            className={styles.innocodeInput}
                        /> 
                        <InnocodeDropdown 
                            options={domainOptions}
                            value={isCustomInput ? 'custom' : selectedDomain}
                            onChange={(value) => handleDomainChange(Array.isArray(value) ? value[0] : value)}
                            className={styles.innocodeInput}
                        />
                    </div>
                </div>
            </div>
            {isEmailCodeSendError && (
                <div className={styles.error_message}>{codeSendErrorText}</div>
            )}
        </div>
        <div className={styles.submit_btn_container}>
            <InnocodeButton
                size="lg"
                className={styles.submit_btn}
                onClick={handleSendCode}
                disabled={!isNextButtonEnabled || isSending}
            >
                다음
            </InnocodeButton> 
        </div>
        </div>
    );
}

export default FindPasswordInputPanel;
